import React from 'react';

// local dependencies
import { CagFilter } from 'modules/cagFilter';

// import { overlay } from 'modules/overlay';
// import { OVERLAY_VIEWS } from 'constants/templates';
// import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cagFilter as CagFilter } from 'ui/views/demo/cagFilter';
 *
 * // render
 * <CagFilter propName='propValue'/>
 */
export class CagFilterDemo extends React.Component {
    constructor() {
        super();

        // bind methods
        this.handleChange = this.handleChange.bind( this );
    }

    /******************************************/

    /**
     * @desc When `apply` button is clicked.
     */
    handleChange( /*values = {}*/ ) {
        log.debug( 'CagFilterDemo.handleChange()' );
    }

    /******************************************/

    // render module
    render() {
        return (
            <div className='ui-cag-filter-demo'>
                <CagFilter
                    displayValue="ALL"
                    filter={ {
                        title: {
                            refId: '',
                            value: 'CAG'
                        },
                        url: '/jsons/cagFilter.jsonc',
                    } }
                    onChange={ this.handleChange }
                />
            </div>
        );
    }
}

// set display name
CagFilterDemo.displayName = 'CagFilterDemo';

// set default props
CagFilterDemo.defaultProps = {};

// prop types
CagFilterDemo.propTypes = {};
